import styled, { css } from "styled-components";

interface IMobileFooterNavigationContainerProps {
  coinsColor: string;
  hasNewNotifications: boolean;
  userIsLogged: boolean;
  gridColunmsToAdd: number;
  shouldEnableIOSLimitations: boolean;
}

export const MobileFooterNavigationContainer = styled.div<IMobileFooterNavigationContainerProps>`
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 100;

  width: 100%;

  border-radius: 12px 12px 0px 0px;

  transition: 0.3s all;
  background-color: ${({ theme }) =>
    theme.colors.globalTopbar.mobileNavigationBackground};
  border-top: 0.5px solid
    ${({ theme }) => theme.colors.globalTopbar.borderColor};

  ul {
    display: grid;
    grid-template-columns: repeat(
      ${({ gridColunmsToAdd, userIsLogged, shouldEnableIOSLimitations }) =>
        userIsLogged
          ? shouldEnableIOSLimitations
            ? 4
            : 3 + gridColunmsToAdd
          : 4},
      1fr
    );
    justify-items: center;

    list-style: none;

    margin: 0;

    li {
      width: 100%;

      display: flex;
      justify-content: center;
      align-items: center;

      > button {
        border: none;
        background-color: transparent;
        width: 100%;
        text-align: center;
      }
    }

    button.notification-button {
      position: relative;

      transition: none;

      ${({ hasNewNotifications }) =>
        hasNewNotifications &&
        css`
          left: 4px;
        `}

      ::after {
        content: "";
        width: 0px;
        height: 0px;
        background-color: red;
        border-radius: 50%;
        position: relative;
        display: block;
        right: 9px;
        top: -5px;

        opacity: 0;

        pointer-events: none;

        ${({ hasNewNotifications }) =>
          hasNewNotifications &&
          css`
            opacity: 1;

            width: 8px;
            height: 8px;
          `}
      }
    }

    a,
    button {
      display: block;
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;

      padding: 1.12rem 1.59rem;
      position: relative;
      overflow: hidden;
    }

    a,
    button {
      color: ${({ theme }) => theme.colors.globalTopbar.textColor};
      transition: 0.3s all;

      :hover {
        cursor: pointer;
        color: ${({ theme }) => theme.colors.globalTopbar.textHoverColor};
      }

      svg path {
        transition: 0.3s all;
      }

      position: relative;

      ::before {
        opacity: 0;

        transition: 0.3s all;
        content: "";

        width: 26px;
        height: 9px;

        background-color: ${({ theme }) => theme.colors.primary};

        position: absolute;
        top: -4px;

        border-radius: 8px;
      }

      &.active {
        ::before {
          opacity: 1;
        }

        svg.menu-icon,
        svg.search-icon {
          path {
            stroke: ${({ theme }) => theme.colors.primary};
          }
        }

        svg.notifications-icon path {
          stroke: ${({ theme }) => theme.colors.primary};
        }

        svg.home-icon path {
          fill: ${({ theme }) => theme.colors.primary};
        }
      }
    }
  }
`;

export const PointsGainedSection = styled.div<{ coinsColor: string }>`
  position: absolute;
  bottom: 50px;
  right: 1rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  z-index: 9999999;

  .gained-coins {
    position: relative;

    background-color: ${({ coinsColor }) => coinsColor}40;

    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.25rem;
    border-radius: 4px;
    width: fit-content;

    z-index: 999999999999999999999999999999;

    padding: 0.125rem 0.25rem;

    p {
      color: ${({ theme }) => theme.groups.primaryText};
      font: 500 0.688rem/0.938rem "Inter";
      margin: 0;
      width: auto;
    }

    svg,
    * {
      width: 0.813rem;
      max-height: 0.813rem;
      fill: ${({ coinsColor }) => coinsColor};
    }
  }

  .gained-exp {
    position: relative;

    background-color: ${({ theme }) =>
      theme.colors.globalTopbar.gamificationExpBackground};

    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.25rem;
    border-radius: 4px;
    width: fit-content;

    padding: 0.125rem 0.25rem;

    p {
      color: ${({ theme }) =>
        theme.colors.globalTopbar.gamificationExpTextColor};
      font: 500 0.688rem/0.938rem "Inter";
      margin: 0;
      width: auto;
    }

    svg,
    * {
      width: 0.625rem;
    }
  }
`;

interface IFullViewMenuProps {
  show: boolean;
}

export const FullViewMenu = styled.div<IFullViewMenuProps>`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 99;
  transition: 0.3s all;

  padding: 0 0 5rem 0;

  overflow: scroll;

  background-color: ${({ theme }) =>
    theme.colors.globalTopbar.mobileNavigationBackground};

  .loader {
    margin: 1.5rem 0 1rem 0;
  }

  .user-info {
    padding: 1rem 1rem 0 1rem;
    width: 100%;

    button {
      width: 100%;
    }
  }

  ${({ show }) =>
    show ? "transform: translateY(0)" : "transform: translateY(100%)"};

  > a,
  > button,
  .switch-theme {
    display: flex;
    align-items: center;
    justify-content: space-between;

    border-top: 1px solid
      ${({ theme }) => theme.colors.globalTopbar.borderColor};
  }

  a,
  span {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  a span {
    max-width: 80%;
  }

  a,
  > button,
  .switch-theme {
    padding: 1rem;
    font: 600 1rem/1.3125rem "Inter";
    transition: 0.3s all;

    color: ${({ theme }) => theme.colors.globalTopbar.textColor};

    :hover,
    :focus {
      color: ${({ theme }) => theme.colors.globalTopbar.textHoverColor};
    }
  }

  > button,
  .switch-theme {
    width: 100%;
    border: none;
    background-color: transparent;

    border-top: 1px solid
      ${({ theme }) => theme.colors.globalTopbar.borderColor};

    :hover {
      cursor: pointer;
    }
  }

  svg.user-icon path {
    fill: ${({ theme }) => theme.colors.globalTopbar.textColor};
  }

  li {
    :first-child {
      border-top: 1px solid
        ${({ theme }) => theme.colors.globalTopbar.borderColor};
    }

    li + li,
    .CTA-container {
      border-top: 1px solid
        ${({ theme }) => theme.colors.globalTopbar.borderColor};
    }
  }
  .CTA-container {
    padding: 0 0 1rem 1rem;

    button {
      width: calc(100% - 1rem);
      box-sizing: border-box;
    }
  }

  svg {
    height: 1rem;
    width: 1rem;
  }
`;

export const ContentItem = styled.li`
  display: flex;
  align-items: center;
  justify-content: space-between;

  width: 100%;
  padding: 0.875rem 1rem;

  border-top: 1px solid ${({ theme }) => theme.colors.globalTopbar.borderColor};

  font-size: 1rem;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.globalTopbar.textColor};

  cursor: pointer;

  :hover,
  :focus {
    color: ${({ theme }) => theme.colors.globalTopbar.textHoverColor};
  }

  svg {
    width: 1.5rem;
    height: 1.5rem;

    path {
      stroke: ${({ theme }) => theme.colors.globalTopbar.textHoverColor};
    }
  }
`;
